export default __webpack_public_path__ + "static/home-banner-top-9e8d6b411c46acc78cd4581ea8e97de5.png";